export enum FractionTsMomentTypeEnum {
  Literal = 'Literal',
  Today = 'Today',
  Yesterday = 'Yesterday',
  Tomorrow = 'Tomorrow',
  This = 'This',
  Last = 'Last',
  Next = 'Next',
  Ago = 'Ago',
  FromNow = 'FromNow',
  Now = 'Now',
  Timestamp = 'Timestamp'
}
